import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
import { useDebouncedCallback } from "use-debounce";
import { BookingButtonProps } from "./BookingButtonProps";
import { BookingProvider } from "./BookingContext/BookingContext";
import { LabelsProvider } from "./LabelsContext/LabelsContext";
import { BookingModalDecision } from "./BookingModalDecision";
import { FeatureFlagsProvider } from "../../Context/FeatureFlagsContext";
import { GtmService } from "../Booking/GtmService";

export const TopbarBookingButton: FC<BookingButtonProps> = ({
  bookingButton,
  cssClass,
}) => {
  const variant = "topbar";
  const [scrollClass, setScrollClass] = useState("btn btn-light btn-cta");
  const [isModalOpened, setIsModalOpened] = useState(false);

  const [windowRendered, setWindowRendered] = useState(false);
  useEffect(() => {
    setIsModalOpened(bookingButton.autoStartBooking);
    setWindowRendered(true);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", debouncedScroll);
    return () => {
      window.removeEventListener("scroll", debouncedScroll);
    };
  }, []);

  const debouncedScroll = useDebouncedCallback(() => {
    if (window.scrollY > 500) {
      setScrollClass("btn btn-cta btn-primary");
    } else {
      setScrollClass("btn btn-light btn-cta");
    }
  }, 200);

  if (!windowRendered) {
    return null;
  }

  const closeModal = () => setIsModalOpened(false);
  const openModal = () => {
    GtmService.bookingCtaClicked(variant, bookingButton.label);
    setIsModalOpened(true);
  };

  const showModal = bookingButton.autoStartBooking || !bookingButton.targetUrl;

  return (
    <LabelsProvider bookingLabels={bookingButton.bookingLabels}>
      <BookingProvider
        dipsAutoQueryMaxRepeats={bookingButton.dipsAutoQueryMaxRepeats}
        filterValues={bookingButton.filterValues}
        newBookingFilterValues={bookingButton.newBookingFilterValues}
        requireParentSsn={bookingButton.requireParentSsn}
        blockedSsnList={bookingButton.blockedSsnList}
        blockedSsnErrorMessage={bookingButton.blockedSsnErrorMessage}
        trackAbEvent={bookingButton.trackAbEvent}
        bookingSearchSetup={bookingButton.bookingSearchSetup}
      >
        {bookingButton.targetUrl ? (
          <a
            className={classNames(cssClass, scrollClass)}
            href={bookingButton.targetUrl}
            onClick={() =>
              GtmService.bookingCtaClicked(
                variant,
                bookingButton.label,
                bookingButton.targetUrl
              )
            }
          >
            <span>{bookingButton.label}</span>
          </a>
        ) : (
          <button
            className={classNames(cssClass, scrollClass)}
            onClick={openModal}
          >
            <span>{bookingButton.label}</span>
          </button>
        )}
        {showModal && (
          <FeatureFlagsProvider
            sdkKey={bookingButton.optimizelyExperimentation?.sdkKey}
          >
            <BookingModalDecision
              bookingButton={bookingButton}
              closeModal={closeModal}
              isModalOpened={isModalOpened}
            />
          </FeatureFlagsProvider>
        )}
      </BookingProvider>
    </LabelsProvider>
  );
};
